module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Filters "), (_vm.is_admin) ? _c('button', {
    staticClass: "btn btn-custom",
    on: {
      "click": function($event) {
        return _vm.toggleFilterModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Filter")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.filtersList), function(r, ir) {
    return _c('div', {
      key: r.id,
      staticClass: "filter",
      class: {
        'filter-disabled': !r.active, 'filter-reject': !r.exclude
      }
    }, [_c('div', {
      staticClass: "text-right filter-controls"
    }, [(_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": ir == 0
      },
      on: {
        "click": function($event) {
          return _vm.moveUpFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": (ir + 1) == _vm.filtersList.length
      },
      on: {
        "click": function($event) {
          return _vm.moveDownFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.toggleFilterModal(r)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.deleteFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Created: "), _c('b', [_vm._v(_vm._s(_vm._f("formatTimestamp")(r.created)))])]), _vm._v(" "), _c('h5', [_vm._v("Priority: "), _c('b', [_vm._v(_vm._s(ir + 1))]), _vm._v(" ("), (r.exclude) ? _c('span', [_vm._v("Acceptance")]) : _c('span', [_vm._v("Filtering")]), _vm._v(" Rate: "), _c('b', [_vm._v(_vm._s(r.rate) + "%")]), _vm._v(")")]), _vm._v(" "), _c('h5', [_vm._v("Status: "), _c('b', [(r.active) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Inactive")])])]), _vm._v(" "), (r.notes) ? _c('h5', [_vm._v("Notes: " + _vm._s(r.notes))]) : _vm._e(), _vm._v(" "), _c('h5', [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          r.showHistory = !r.showHistory
        }
      }
    }, [(!r.showHistory) ? _c('span', [_vm._v("Show")]) : _c('span', [_vm._v("Hide")]), _vm._v(" edit history")])]), _vm._v(" "), (r.showHistory) ? _c('div', {}, [_c('table', {
      staticClass: "table table-condensed"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Active")]), _vm._v(" "), _c('th', [_vm._v("Priority")]), _vm._v(" "), _c('th', [_vm._v("Filter")])])]), _vm._v(" "), _c('tbody', [_vm._l((r.history), function(h) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatTimestamp")(h.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(h.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(h.priority))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(h.rule))])])
    }), _vm._v(" "), (!r.history.length) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "4"
      }
    }, [_c('i', [_vm._v("Empty")])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('h5', [(r.exclude) ? _c('b', [_vm._v("Accept")]) : _c('b', [_vm._v("Reject")]), _vm._v(" " + _vm._s(r.rate) + "% of the leads matching this Rule:")]), _vm._v(" "), (r.rulesError) ? _c('h5', {
      staticClass: "rules-error"
    }, [_c('b', [_vm._v("Please check this Rule")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rules",
      class: {
        'rules-error': r.rulesError
      }
    }, [_c('boolean-expression-widget', {
      attrs: {
        "expression": r.rule
      },
      on: {
        "updateExpression": function($event) {
          return _vm.updateExpression($event, r)
        }
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.is_admin) ? _c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveTable()
      }
    }
  }, [(_vm.errorState) ? _c('i', {
    staticClass: "fa fa-warning"
  }) : _vm._e(), _vm._v(" Save")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.showFilterModal) ? _c('filter-modal', {
    attrs: {
      "integrations": _vm.integrations,
      "filter": _vm.filter
    },
    on: {
      "close": function($event) {
        _vm.showFilterModal = false
      },
      "save": _vm.saveFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRuleModal) ? _c('rule-modal', {
    attrs: {
      "available-fields": _vm.fields,
      "condition": _vm.condition
    },
    on: {
      "close": function($event) {
        _vm.showRuleModal = false
      },
      "save": _vm.saveCondition
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235260b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/FiltersSettings.vue
// module id = 627
// module chunks = 0